import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ReportActions, { reportActionTypes } from '../actions/reportActions';
import ReportServices from '../services/reportServices';

/**
 *
 * @param {*} action
 */
function* _getReports(action) {
  const {
    firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, moType, status, sellerId, costingMethod, customerId, category, callback,
  } = action;
  try {
    yield put(ReportActions.getReportsLoading(true));
    const reports = yield ReportServices.getReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, sellerId, costingMethod, customerId, category);
    if (['purchase_by_product', 'purchase_by_vendor', 'inventory_adjustment', 'inventory_summary'].includes(reportType)) {
      yield put(ReportActions.getReportsSuccess({ reportData: reports?.data[0], reportType }));
    } else if (['sales_ledger', 'purchase_ledger'].includes(reportType)) {
      yield put(ReportActions.getReportsSuccess({
        reportData: {
          purchase_ledger: reports.result,
          fileBase64: reports.file_base64,
        },
        reportType,
      }));
    } else if (['stock_inward_report', 'stock_outward_report', 'stock_transfer_report', 'inventory_report', 'sales_by_customer', 'sales_by_product', 'mo_report'].includes(reportType)) {
      yield put(ReportActions.getReportsSuccess({ reportData: reports, reportType }));
    }
    if (callback) {
      callback();
    }
    yield put(ReportActions.getReportsLoading(false));
  } catch (error) {
    yield put(ReportActions.getReportsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportActionTypes.GET_DOWNLOAD_REPORTS.ERROR, error));
  }
}
/**
 *
 */
function* getReports() {
  yield takeEvery(reportActionTypes.GET_REPORTS.REQUEST, _getReports);
}

/**
 *
 * @param {*} action
 */
function* _getProductionReports(action) {
  const {
    tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category,
  } = action;
  try {
    yield put(ReportActions.getProductionReportsLoading(true));
    const reports = yield ReportServices.getProductionReports(tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category);
    yield put(ReportActions.getProductionReportsSuccess(reports));
    yield put(ReportActions.getProductionReportsLoading(false));
  } catch (error) {
    yield put(ReportActions.getProductionReportsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportActionTypes.GET_PRODUCTION_REPORTS.ERROR, error));
  }
}
/**
 *
 */
function* getProductionReports() {
  yield takeEvery(reportActionTypes.GET_PRODUCTION_REPORTS.REQUEST, _getProductionReports);
}

function* _getStockAgeingReports(action) {
  const {
    tenantIds, method, interval, steps, date, departmentId, currentPage, limit, category,
  } = action;
  try {
    yield put(ReportActions.getStockAgeingReportsLoading(true));
    const reports = yield ReportServices.getStockAgeingReports(tenantIds, method, interval, steps, date, departmentId, currentPage, limit, category);
    yield put(ReportActions.getStockAgeingSuccess(reports));
    yield put(ReportActions.getStockAgeingReportsLoading(false));
  } catch (error) {
    yield put(ReportActions.getStockAgeingReportsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportActionTypes.GET_STOCK_AGEING_REPORTS.ERROR, error));
  }
}
/**
 *
 */
function* getStockAgeingReports() {
  yield takeEvery(reportActionTypes.GET_STOCK_AGEING_REPORTS.REQUEST, _getStockAgeingReports);
}

/**
 *
 * @param {*} action
 */
function* _getDownloadReports(action) {
  const {
    firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category, callback,
  } = action;
  try {
    yield put(ReportActions.getDownloadReportsLoading(true));
    const reportDownload = yield ReportServices.getReportsDownload(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category);
    if (!reportDownload) {
      notification.open({
        type: 'error',
        message: reportDownload.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(ReportActions.getDownloadReportsLoading(false));
      if (fileReportType === 'download') {
        const link = document.createElement('a');
        link.target = '_blank';
        link.download = `report-${reportName}`;
        link.href = URL.createObjectURL(
          new Blob([reportDownload], { type: reportDownload.type }),
        );
        link.click();
        notification.open({
          type: 'warning',
          message: 'Please wait while the report is being prepared.',
          duration: 4,
          placement: 'top',
        });
      } else {
        yield put(ReportActions.getDownloadReportsSuccess(reportDownload?.message));
        notification.open({
          type: 'success',
          message: 'We are processing your request. You will receive the data on your email.',
          duration: 4,
          placement: 'top',
        });
      }
      if (callback) {
        callback();
      }
      yield put(ReportActions.getDownloadReportsLoading(false));
    }
  } catch (error) {
    yield put(ReportActions.getDownloadReportsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportActionTypes.GET_DOWNLOAD_REPORTS.ERROR, error));
  }
}
/**
 *
 */
function* getDownloadReports() {
  yield takeLatest(reportActionTypes.GET_DOWNLOAD_REPORTS.REQUEST, _getDownloadReports);
}

/**
 *
 */
export default function* reportSaga() {
  yield all([
    getReports(),
    getDownloadReports(),
    getProductionReports(),
    getStockAgeingReports(),
  ]);
}
